<template>
  <div class="event__meta">
    <ul class="icon-list">
      <li
        v-if="eventStartFormatted && !isRegularEvent"
        :class="{
          'item-without-divide':
            eventEndFormatted &&
            !(eventIsSameDay || eventIsAllDay || isRegularEvent),
        }"
        aria-label="Event Start"
      >
        <i class="icon icon--lg">
          <Icon name="fa6-regular:calendar" />
        </i>
        <span>
          {{ eventStartFormatted }}
          <span v-if="eventStartTimeFormatted">
            , {{ eventStartTimeFormatted }}
          </span>
          <span v-if="eventIsSameDay && eventEndTimeFormatted">
            – {{ eventEndTimeFormatted }}
          </span>
        </span>
      </li>
      <li
        v-if="
          eventEndFormatted &&
          !(eventIsSameDay || eventIsAllDay || isRegularEvent)
        "
        aria-label="Event End"
      >
        <i class="icon icon--lg">
          <Icon name="fa6-solid:arrow-right" />
        </i>
        <span>
          {{ eventEndFormatted }}
          <span v-if="eventEndTimeFormatted">
            , {{ eventEndTimeFormatted }}
          </span>
        </span>
      </li>
      <li v-if="eventLocation" aria-label="Event Location">
        <i class="icon icon--lg">
          <Icon name="fa6-solid:location-dot" />
        </i>
        <span class="whitespace-pre-line">
          {{ eventLocation }}
        </span>
      </li>
      <li v-if="eventCost" aria-label="Event Cost">
        <i class="icon icon--lg">
          <Icon name="fa6-solid:dollar-sign" />
        </i>
        <span>
          {{ eventCost }}
        </span>
      </li>
      <li v-if="eventOrganiser">
        <i class="icon icon--lg">
          <Icon name="fa6-solid:link" />
        </i>
        <span v-if="eventOrganiserLink">
          <a
            :href="eventOrganiserLink"
            aria-label="Event Organiser - opens in new tab"
            rel="external"
            target="_blank"
          >
            {{ eventOrganiser }}
          </a>
        </span>
        <span v-else>
          {{ eventOrganiser }}
        </span>
      </li>
      <li v-if="eventRegistrationLink">
        <i class="icon icon--lg">
          <Icon name="fa6-solid:arrow-up-right-from-square" />
        </i>
        <a
          :href="eventRegistrationLink"
          aria-label="Event Registration - opens in new tab"
          rel="external"
          target="_blank"
        >
          {{ linkLabel }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { EventsStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: EventsStoryblok
}>()
const {
  eventStartFormatted,
  eventEndFormatted,
  eventStartTimeFormatted,
  eventEndTimeFormatted,
  eventIsAllDay,
  eventLocation,
  isRegularEvent,
  eventIsSameDay,
} = useEvent(toRefs(props))
const eventCost = computed(() => props.blok.cost)
const eventOrganiser = computed(() => props.blok.organiser)
const eventOrganiserLink = computed(() => props.blok.organiser_link?.url)
const linkLabel = computed(() => props.blok.link_label || 'Find out more')
const eventRegistrationLink = computed(() => props.blok.register_link?.url)
</script>

<style lang="less" scoped>
.event__meta {
  .rounded-sm();

  background: @color-fill-normal;
  padding: 0 @gutter-sm;
  max-width: @375px;
}
</style>
